export enum LoggingMessage {
    EmptySourceCode = 'Empty source code. Obfuscation canceled...',
    ObfuscationCompleted = 'Obfuscation completed. Total time: %s sec.',
    ObfuscationStarted = 'Obfuscation started...',
    RandomGeneratorSeed = 'Random generator seed: %s...',
    TransformationStage = 'Transformation stage: %s...',
    Version = 'Version: %s'
}
